module.exports = __webpack_public_path__ + "static/img/gz_03.0625995.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_03.jpg
// module id = 9aW/
// module chunks = 0